import articleSearchTagsAtom from '../searchTags.atom'
import useEntity from '../../../../../../recoil/useEntity/useEntity'
import { IFaqArticleSearchTag } from '../../../faq.types'
import faqApi from '../../../faq.api'

const useArticleSearchTag = (id: IFaqArticleSearchTag['id']) => {
  const articleSearchTags = useEntity({
    atom: articleSearchTagsAtom,
    entityId: id,
    itemFetcher: faqApi.getArticleSearchTag,
    resource: 'faq.articleSearchTags',
  })

  return { tag: articleSearchTags.entity, loading: articleSearchTags.loading }
}

export default useArticleSearchTag
